import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ColDef, GetMainMenuItemsParams, GridApi, GridReadyEvent, IDatasource, IGetRowsParams, MenuItemDef, RowModelType, SortModelItem } from 'ag-grid-community';
import 'ag-grid-enterprise';
import _, { filter, uniq } from 'lodash';
import moment from 'moment';
import { debounceTime, from, Observable, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { FilterService } from 'src/app/services/filter.service';
import { AlertIconComponent } from '../../shared/alert-icon/alert-icon.component';
import { HoverOverComponent } from '../../shared/hover-over/hover-over.component';
import { PatientValueGetterComponent } from '../../shared/patient-value-getter/patient-value-getter.component';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { DeviceDetectionService } from 'src/app/services/detectipad.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { HoverOverClickComponent } from '../../shared/hover-over-click/hover-over-click.component';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { PatientsFollowUpComponent } from '../../shared/patient-value-getter/patients-follow-up.component';
import { RouterHandlerService } from 'src/app/services/router-handler.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ServerExportPopupComponent } from '../../shared/server-export-popup/server-export-popup.component';
import { PatientsActionNotesComponent } from '../../shared/patient-value-getter/patients-action-notes.component';
import { GridStateService } from 'src/app/services/grid-state.service';
import { HashtagService } from '../../shared/comments-notes/hashtag.service';
import { PreferencesComponent } from '../../shared/preferences/preferences.component';
import { DashboardService } from 'src/app/services/dashboard.service';
import { PhiTimerService } from "src/app/services/phi-timer.service";
import { LoginPopupComponent } from "../../shared/login-popup/login-popup.component";
import { PhiSecurityService } from "src/app/services/phi-security.service";
import { PatientsBadgesComponent } from '../../shared/patient-value-getter/patients-badge.component';
import { SessionService } from 'src/app/services/session.service';
import { TaskManagementDialogComponent } from "../../direct/components/task-management-dialog/task-management-dialog.component";

@Component({
    selector: "app-server-side-list",
    templateUrl: "./server-side-list.component.html",
    styleUrls: ["./server-side-list.component.scss"],
    standalone: false
})

export class ServerSideListComponent implements OnInit, OnDestroy {
  static key = 10050201;

  @Input("pageKey") pageKey: any;
  @Input("paginates") paginates: any;
  @Input("dataLoadLocation") dataLoadLocation = false;
  @Input("item") item: any = {};

  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();

  @ViewChild("PatientListDiv", { static: true }) PatientListDiv!: ElementRef;
  @ViewChild("patientJourney", { static: true }) patientJourney!: ElementRef;

  public gridApi!: GridApi;
  public gridColumnApi: any;
  columnDefs: ColDef[] = [];
  defaultColumnDefs: ColDef[] = [];
  public defaultExportParams = {};
  public defaultColDef: ColDef<any> = {
    flex: 1,
    sortable: true,
    resizable: true,
    filter: true,
    wrapText: true,
    autoHeight: false,
    headerClass: "my-header-class",
  };
  headerNames: any = [];
  phiDisplayNames: any = [];
  reqSubcription: Subscription[] = [];
  countApiSubscription?: Subscription;
  private rowDataSubscription?: Subscription;
  private phiTimerSubscription: Subscription | null = null;
  infoData: any;
  isDataLoading: any;
  isDataLoaded = false;
  phiToggle: any;
  phiToggleName: any;
  headerIcons: any;
  inputTypeBox: any;
  heading = "Processing Status";
  cardName: any;
  cardId: any;
  userState: any;
  locationName: any;
  accountKey: any;
  state: any;
  refSource: any;
  routerQueryParam: any;
  prescriberId: any;
  lagging_indicator: any;
  rx_type: any;
  rowHeight = 50;
  loadingTemplate = `<span class="ag-overlay-loading-center">Loading...</span>`;
  noRowsTemplate = `<span>Loading...</span>`;
  overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
  overlayNoRowsTemplate = '<span class="ag-overlay-no-rows-center">No data to show</span>';
  emptyArray: any;
  testData: any;
  isPhiData: any[] = [];
  gridsize: any = 30;
  sliderValue = 1;
  rowStyle = { "border-bottom": "#f3f3f3 1px solid" };
  paginationPageSize = 10;
  clientKey: any;
  moduleKey: any;
  dashboardKey: any;
  patientIdArray: any = [];
  phiChecked = false;
  pendingStatusData: any[] = [];
  nonPendingStatusData: any[] = [];
  pendingFirstLoaded = true;
  menuTabs = ["generalMenuTab", "columnsMenuTab"];
  menuTabss = ["generalMenuTab", "columnsMenuTab"];
  sliderActivityConfig: any;
  paginateConig: any;
  from_day: any;
  to_day: any;
  loader: Boolean = true;
  moduleName: any;
  decryptedParams: any;
  alertColumnAvailable: any;
  selectedColumnData: any;
  selectedSearchByKey: any;
  serverSideSearchFilterText: any;
  startIndex: any;
  endIndex: any;
  isApiLoadCount: any = 0;
  prCardId: any;
  dataLoadApi = 1000;
  public rowModelType: RowModelType = 'infinite';
  public cacheBlockSize = 1000;
  public cacheOverflowSize = 2;
  public maxConcurrentDatasourceRequests = 2;
  public infiniteInitialRowCount = 1;
  public maxBlocksInCache = 3;
  rowData: any = [];

  public themeClass: string = 'ag-theme-alpine'; // Updated to a more commonly used theme
  iGetRowsParams: any;
  loadFirstTime = false;
  rowDataCount: any = 0;

  // Static Icons
  status_tick = "status_tick";
  status_na = "status_na";
  status_pending = "status";
  status_circle = "status_circle";

  valueToDisplay: any;
  report_type: any;
  patientId: any;
  colorMap: { [key: string]: string } = {};
  filterValue: any;
  filterSearchParams: any;
  dataforTesting: any[] = [];
  isUserClick = false;
  sortModel: any;
  hashtagInList = false;
  widgetUniqKey: any;
  error_name: any;
  private nullColumnEvaluated = false;
  sortDesignModel:any = [];
  private phiAccessSubscription: Subscription | any;
  defaultPreference:any;
  onloadPreference = false;

  // Horizontal scroll icons (shown on hover when the grid overflows horizontally)
  canScrollLeft = false;
  canScrollRight = false;
  scrollBtnTop = 0; // vertical center of the grid's visible body viewport (px)
  private scrollRafPending = false;
  private onDocScroll = () => {
    if (this.scrollRafPending) return;
    this.scrollRafPending = true;
    requestAnimationFrame(() => {
      this.scrollRafPending = false;
      this.updateScrollButtons();
    });
  };

  onBtShowLoading() {
    setTimeout(() => {
      this.loader = true
    });
  }
  onBtHide() {
    setTimeout(() => {
      this.loader = false;
    });
  }

  constructor(
    public filterService: FilterService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private routerHandlerService: RouterHandlerService,
    private dataService: DataService,
    private newFilterService: NewFilterService,
    private mixpanelService: MixpanelService,
    public deviceDetectionService: DeviceDetectionService,
    private constantsService: ConstantsService,
    private cdr: ChangeDetectorRef,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private navigationService: NavigationService,
    private gridStateService: GridStateService,
    private hashtagService: HashtagService,
    private dashboardService: DashboardService,
    private phiTimerService: PhiTimerService,
    private phiSecurityService: PhiSecurityService,
    private sessionService: SessionService,
    private currency: CurrencyPipe
  ) {
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.onBtShowLoading();
        this.loadApiDataCount();
      })
    );

    // PHI access check only on brand selection/load
    // this.reqSubcription.push(
    //   this.filterService.lastRefreshedDate.subscribe((res: any) => {
    //     let headerConfig = this.item?.config?.['widget_header_configuration'] || [];
    //     const hasPhiHiddenToggle = headerConfig.some((f:any) => f.add_header && f.hidden_toggle);
    //     this.hasPhiHiddenToggle = false;
    //     if(hasPhiHiddenToggle) {
    //       this.getPhiUserAccess(res);
    //     }
    //   })
    // );

    this.reqSubcription.push(
      this.filterService.hoverDataRefresh.subscribe((res: any) => {
        // this.localApi();
      })
    );

    this.reqSubcription.push(
      this.filterService.refreshAlertDelete.subscribe((res: any) => {
        // this.refreshAlertData();
        this.fetchDataAndKeepPage()
      })
    );

    this.reqSubcription.push(
      this.hashtagService.refreshHashtags.subscribe((res: any) => {
        this.fetchDataAndKeepPage()
      })
    );

    this.reqSubcription.push(
      this.hashtagService.removeHashtagsGlobal.subscribe((res: any) => {
        if (this.hashtagInList) {
          this.onBtShowLoading();
          this.loadApiDataCount();
        }
      })
    )

    this.reqSubcription.push(
      this.filterService.refreshStatusChangeData.subscribe((res: any) => {
        // this.onBtShowLoading()
        this.loadStatusChange(res);
      })
    );

    // this.filterService.isPHIFunc.subscribe((res:any)=> {
    //   this.isPHIFunc(res)
    // })

    // this.filterService.onQuickFilter.subscribe((res:any)=> {
    //   this.onQuickFilterChanged(res)
    // })

    // this.filterService.exportXls.subscribe((res:any)=> {
    //   this.exportXls()
    // })

    // Journey Popup in Mobile and IPAD
    this.filterService.getDataPatientJourneyDataHold.subscribe((res: any) => {
      this.journeyPopupData(res)
    })

    this.filterService.flagUpdateOnscreen.subscribe((res: any) => {
      this.gridApi.refreshCells({
        force: true,
        suppressFlash: true // Optionally prevent flashing effect
      });
      // this.filterService.gridApi?.setRowData(this.rowData);
    })
  }

  ngOnInit(): void {

    // if(sessionStorage.getItem('phiLogged') && this.filterService.hasPhiHiddenToggle) {
    //   this.phiChecked = true;
    //   this.filterService.phiChecked = this.phiChecked;
    // }

    // Subscribe to PHI timer expiration events
    // this.phiTimerSubscription = this.phiTimerService.onTimerExpired$.subscribe(
    //   () => {
    //     // Only show notification if PHI is currently enabled AND no notification is already showing
    //     if (
    //       this.phiChecked &&
    //       !this.phiTimerService.isNotificationDialogShowing()
    //     ) {
    //       // Mark that notification is being shown
    //       this.phiTimerService.setNotificationShowing(true);

    //       // Show notification dialog
    //       const dialogRef = this.dialog.open(LoginPopupComponent, {
    //         width: "450px",
    //         disableClose: true,
    //         data: {
    //           mode: "notification",
    //           message:
    //             "PHI access has expired for security. Please re-enable PHI columns by logging in again.",
    //         },
    //       });

    //       // After user acknowledges, disable PHI
    //       dialogRef.afterClosed().subscribe(() => {
    //         // this.phiChecked = false;

    //         // Refresh grid to hide PHI data
    //         if (this.gridApi) {
    //           this.onBtShowLoading();
    //           this.loadApiDataCount();
    //         }

    //         // Sync global state
    //         this.filterService.isPHIFunc.next(false);
    //         // Explicitly disable restrictions to remove overlay
    //         this.phiSecurityService.disableRestrictions();

    //         // Stop the timer (this also resets the notification flag)
    //         this.phiTimerService.stopTimer();
    //       });
    //     }
    //   },
    // );

    this.route.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';
      this.cardName = p['cardName'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });

    this.isDataLoading = "Loading...";

    this.defaultExportParams = {
      columnGroups: true,
      fileName: this.item.config["report_heading"],
    };

    let cfg = this.item.config;
    // this.widgetUniqKey = this.item?.widget_uniq_key || 'widget_' + this.dashboardKey;
    this.widgetUniqKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    this.dataLoadApi = cfg?.["count_of_api"] || 1000;
    this.paginationPageSize = cfg["default_pagenation"] || 10;
    this.dataLoadApi = cfg?.["count_of_api"] || 1000;
    this.cacheBlockSize = this.dataLoadApi;

    // config for grid
    this.onBtShowLoading();
    this.loadDataNewGridConfig();

    const dyHeight = cfg["height_configuration"]?.["value"];
    if (dyHeight !== "fixed") {
      const observer = new ResizeObserver((entries: any) => {
        setTimeout(() => {
          this.onSizeChange.emit(entries[0].contentRect.height);
        }, 0); // Defers execution to the next event loop cycle
      });
      observer.observe(this.PatientListDiv?.nativeElement);
    }
    this.cdr.detectChanges();

    // Keep the scroll icons centered on the visible viewport while the page /
    // any ancestor container scrolls (capture phase catches inner scrolls too).
    window.addEventListener('scroll', this.onDocScroll, true);

    // Load Data from API

    // if (this.filterService.locationPresId) {
    //   this.loadApiData();
    // }
  }

  getPreferences() {
    if (this.widgetUniqKey) {
      let obj = {
        dashboard_key: this.dashboardKey,
        page_name: this.item.config?.["page_name"] || undefined,
        page_key: this.pageKey,
        widget_uinique_key: this.widgetUniqKey
      }
      this.dataService.getPreference(obj).subscribe((res: any) => {
        this.onloadPreference = true;
        if (res && res.length) {
          let value = res?.[0]?.preference_value ? JSON.parse(res?.[0]?.preference_value) : '';
          this.defaultPreference = value || this.getDefaultPreference();
          this.parsePreference(value)
        } else {
          this.defaultPreference = this.getDefaultPreference();
        }
      }, err => {
        this.onloadPreference = true;
        this.defaultPreference = this.getDefaultPreference();
      })
    }
  }

  getDefaultPreference() {
    return this.columnDefs
      .filter((m: any) => !this.headerNames.includes(m.field))
      .map((m: any) => ({
        name: m.headerName
      }));
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.filterService.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.gridApi.setQuickFilter(this.filterValue);
    this.refreshGrid();

    this.gridApi.showLoadingOverlay();

    // User state
    // Defer async operation
    setTimeout(async () => {
      if(!this.widgetUniqKey) {
        // this.widgetUniqKey = this.item?.widget_uniq_key || 'widget_' + this.dashboardKey;
        this.widgetUniqKey = this.item?.widget_uniq_key || this.item?.key || 'default';
      }
      const getUserState = await this.gridStateService.loadGridState(this.widgetUniqKey);

      if (getUserState) {
        const state = getUserState;
        this.startIndex = state.startIndex;

        this.selectedSearchByKey = state?.search?.search_prm;
        this.serverSideSearchFilterText = state?.filterValue || '';
        // this.phiChecked = state?.phi_flag || this.filterService.phiChecked;
        // this.filterService.phiChecked = this.phiChecked;
        
        this.searchDynamicParams = state?.searchDynamicParams || {};

        this.filterValue = state?.filterValue || '';
        this.filterSearchParams = state?.search || '';
        if (state?.pageSize) {
          this.paginationPageSize = state?.pageSize;
        }

        let fndAlertColumn = this.columnDefs.find((f: any) => f?.sort_column_name == state?.sort?.sort_col);
        // let initSort = this.sortDesignModel.find((f:any) => f.id == this.sortModel[0].colId)?.sort || this.sortModel[0].colId;

        let initSort = fndAlertColumn?.field || state.sort.sort_col;

        if (state?.sort) {
          this.gridColumnApi.applyColumnState({
            state: [{ colId: initSort, sort: state.sort.sort_order }],
            applyOrder: false,
            suppressServerSideEvent: true
          });
        }

      }
      this.gridApi.paginationSetPageSize(this.paginationPageSize);
    });
  }

  serverSidePagination() {
    this.onBtShowLoading();
    const datasource: IDatasource = {
      getRows: (params: IGetRowsParams | any) => {

        this.startIndex = params.startRow
        this.endIndex = params.endRow

        this.onBtShowLoading();
        this.gridApi.showLoadingOverlay();

        if (this.rowDataSubscription) {
          this.rowDataSubscription.unsubscribe(); // Cancel the previous request
        }

        // Call API and handle the response
        this.rowDataSubscription =
          this.getRowApiData(this.startIndex, this.endIndex, params).subscribe((data: any) => {
            this.rowData = data && Array.isArray(data) ? data : [];
            if (this.rowData.length == 0) {
              this.error_name = 'There is no data for this time period';
            } else {
              this.error_name = '';
            }

            let fndFindColumns = this.defaultColumnDefs.find((f: any) => f.removeNullColumns);
            if (fndFindColumns) {
              this.removeNullColumns();
            }
            this.parsePreference(this.defaultPreference);

            setTimeout(async () => {
              const getUserState = await this.gridStateService.loadGridState(this.widgetUniqKey);

              // No data, tell grid to stop loading and show no rows overlay
              if (this.rowData.length === 0) {
                params.successCallback([], params.startRow);
                this.gridApi.showNoRowsOverlay();
              } else {
                const lastRow =
                  Number.isFinite(this.rowDataCount) && this.rowDataCount >= 0
                    ? this.rowDataCount
                    : params.startRow + this.rowData.length; // fallback so grid never shows "?"
                params.successCallback(this.rowData, lastRow);

                if (getUserState?.page) {
                  this.gridApi.paginationGoToPage(getUserState?.page);
                }

                this.gridApi.hideOverlay();
                this.gridApi.refreshCells();
              }
              
              setTimeout(() => {
                this.onBtHide();
                this.updateScrollButtons();
              }, 1000);
            });

          },
            (err: any) => {
              params.successCallback([], params.startRow);
              this.gridApi.hideOverlay();
              this.gridApi.showNoRowsOverlay();
              this.error_name = friendlyApiErrorMessage(err);
              this.onBtHide();
            })

      }
    };

    this.gridApi.setDatasource(datasource);
  }

  removeNullColumns(): void {
    // stop if already evaluated once
    if (this.nullColumnEvaluated) return;

    if (!this.rowData || this.rowData.length === 0) return;

    const filterFn = (colDef: ColDef) => {
      if (!(colDef as any).removeNullColumns) return true;

      const field = colDef.field;
      if (!field) return true;

      return this.rowData.some((row: any) => {
        const value = row[field];
        return value !== null && value !== undefined && String(value).trim() !== '';
      });
    };

    this.columnDefs = this.columnDefs.filter(filterFn);
    this.defaultColumnDefs = this.defaultColumnDefs.filter(filterFn);

    // mark as done (VERY IMPORTANT)
    this.nullColumnEvaluated = true;

    // refresh grid columns
    this.gridApi?.setColumnDefs(this.columnDefs);
  }

  getRowApiData(startRow: number, endRow: number, params?: any): Observable<any> {
    return from((async () => {
      const api = this.item.config["list_of_api"] || {};
      const endpoint = this.item.config?.["list_of_api_endpoint"] || '';

      let obj: any = {
        activity_since_days: this.filterService.sliderValue || undefined,
        report_typ: this.filterService.report_type || "D",
        prescriber_office_location: this.locationName || undefined,
        api_key: api.api_key,
        startIndex: startRow,
        pageSize: this.dataLoadApi,
        module_key: this.apiService.getModuleKey(),
        phi_flg: this.filterService.phiChecked ? "Y" : "N"
      };
      obj['column_nm'] = this.setPreferencesColumn();

      // Load saved state from indexedDB
      const getUserState = await this.gridStateService.loadGridState(this.widgetUniqKey);
      if (getUserState) {
        const saved = getUserState.config;
        if (saved?.search) Object.assign(obj, saved.search);
        if (saved?.sort) Object.assign(obj, saved.sort);
      }

      // Apply filter params from live state
      if (this.filterValue) {
        Object.assign(obj, this.filterSearchParams || {});
      }

      if (this.searchDynamicParams && Object.keys(this.searchDynamicParams).length > 0) {
        Object.assign(obj, this.searchDynamicParams);
      }

      // Handle sorting and save state
      if (params?.sortModel?.length > 0) {
        this.sortModel = params.sortModel;

        // let initSort = this.sortModel[0].colId;
        let initSort = this.sortDesignModel.find((f: any) => f.id == this.sortModel[0].colId)?.sort || this.sortModel[0].colId;
        const sort = {
          sort_col: initSort,
          sort_order: this.sortModel[0].sort
        };
        Object.assign(obj, sort);
        await this.gridStateService.saveGridStates({
          id: this.widgetUniqKey,
          config: { sort }
        });
      } else {
        const defaultSort = {
          sort_col: this.item.config?.["initial_sorting"]?.api_resp_column_nm || "patient_initiation_date",
          sort_order: this.item.config?.["initial_sorting_order"] || "desc"
        };
        Object.assign(obj, defaultSort);
        await this.gridStateService.saveGridStates({
          id: this.widgetUniqKey,
          config: { sort: defaultSort }
        });
      }

      const query = Object.assign({}, this.filterService.baseQuery, obj);

      // Return the actual API observable
      return this.httpClient.post<any[]>(`${this.apiService.apiBaseUrl}/${endpoint || 'PSS/get-patient-list'}`, query).toPromise();
    })());
  }

  fetchDataAndKeepPage() {
    const currentPage = this.gridApi.paginationGetCurrentPage();

    this.getRowApiData(this.startIndex, this.dataLoadApi).subscribe((response: any) => {
      if (response) {
        const updatedData = response;
        let findColumn: any = this.columnDefs.find((f: any) => f.uniqNavigationColumn);
        if (this.selectedColumnData && updatedData.length && findColumn) {
          let fndRow = updatedData.find((f: any) => f[findColumn.field] == this.selectedColumnData[findColumn.field]);
          if (fndRow) {
            const rowIndex = this.rowData.findIndex((res: any) => res[findColumn.field] == fndRow[findColumn.field]);
            if (rowIndex !== -1) {
              this.rowData[rowIndex] = fndRow
              const datasource: IDatasource = {
                getRows: (params: IGetRowsParams) => {
                  params.successCallback(this.rowData, this.rowDataCount || 0);
                  setTimeout(() => {
                    this.gridApi.refreshCells();
                  }, 100);
                },
              };

              // Reassign the datasource to the grid
              this.gridApi.setDatasource(datasource);

              // Set the grid to the previous page
              setTimeout(() => {
                this.gridApi.paginationGoToPage(currentPage);
              }, 0);
            }
          }
        }
      }
    })
  }

  paginationChanged(event: any) {
    if (!event?.newPage) return;
    if (!this.gridApi) return;
    if (this.isUserClick) {
      let config = {
        dashboardKey: this.dashboardKey,
        filterValue: this.filterValue,
        search: this.filterSearchParams
      }

      const page = this.gridApi.paginationGetCurrentPage();
      this.gridStateService.saveGridStates({ id: this.widgetUniqKey, config: { page } })
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {
    if (event.target.closest('.ag-paging-button')) {
      this.isUserClick = true;
    } else {
      this.isUserClick = false;
    }
  }

  refreshAlertData() {
    // Call API and handle the response
    this.reqSubcription.push(
      this.getRowApiData(this.startIndex, this.endIndex).subscribe((data: any) => {
        setTimeout(() => {
          this.gridApi.refreshCells(); // Refresh cells safely
        }, 100);
      }, (err: any) => {
        console.error('Error fetching data:', err);
      })
    );
  }

  refreshGrid() {
    if (this.gridApi) {
      let a = this.gridColumnApi?.columnModel?.columnDefs?.length;
      if (a < 5) {
        this.gridApi.sizeColumnsToFit();
      } else {
        const allColumnIds: string[] = [];
        this.gridColumnApi.getColumns()!.forEach((column: any) => {
          // column.minWidth = 150;
          if (column.colId == "current_status") {
            column.minWidth = 280;
          }
          if (column.colId == "alert" || column.colId == "alert_col_value") {
            column.minWidth = 230;
          }
          allColumnIds.push(column.getId());
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
      }
    }
    this.updateScrollButtons();
  }

  // Resolve the ag-grid horizontal scroll viewport element
  private getGridScrollViewport(): HTMLElement | null {
    const host = this.gridList?.nativeElement as HTMLElement;
    if (!host) return null;
    return (host.querySelector('.ag-body-horizontal-scroll-viewport')
      || host.querySelector('.ag-center-cols-viewport')) as HTMLElement | null;
  }

  // Recalculate whether the left/right scroll icons should be shown
  updateScrollButtons(): void {
    const viewport = this.getGridScrollViewport();
    if (!viewport) {
      this.canScrollLeft = false;
      this.canScrollRight = false;
      return;
    }
    const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    this.canScrollLeft = viewport.scrollLeft > 1;
    this.canScrollRight = viewport.scrollLeft < maxScrollLeft - 1;

    // Center the icons on the VISIBLE part of the grid's rows viewport (content
    // area), clipped to what is actually on screen - not the full body height
    // and not the whole grid container / pagination.
    const host = this.gridList?.nativeElement as HTMLElement;
    const body = host?.querySelector('.ag-body-viewport') as HTMLElement | null;
    if (host && body) {
      const hostRect = host.getBoundingClientRect();
      const bodyRect = body.getBoundingClientRect();
      const screenHeight = window.innerHeight || document.documentElement.clientHeight;

      // Intersect the body viewport with the visible screen region
      const visibleTop = Math.max(bodyRect.top, 0);
      const visibleBottom = Math.min(bodyRect.bottom, screenHeight);
      const visibleCenter = visibleTop < visibleBottom
        ? (visibleTop + visibleBottom) / 2          // center of what's on screen
        : bodyRect.top + bodyRect.height / 2;        // fallback: body center

      this.scrollBtnTop = visibleCenter - hostRect.top;
    }

    this.cdr.detectChanges();
  }

  scrollGridLeft(): void {
    const viewport = this.getGridScrollViewport();
    if (viewport) {
      viewport.scrollTo({ left: viewport.scrollLeft - 200, behavior: 'smooth' });
    }
  }

  scrollGridRight(): void {
    const viewport = this.getGridScrollViewport();
    if (viewport) {
      viewport.scrollTo({ left: viewport.scrollLeft + 200, behavior: 'smooth' });
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateScrollButtons();
  }

  localApi() {
    let cfg = this.item.config;
    let api_key = "100201";
    let reports: any[] = cfg["report_status_column"];
    let patient_id: any = null;
    if (reports) {
      reports.forEach((a: any) => {

        let obj: any = {
          activity_since_days: this.filterService.sliderValue || undefined,
          report_typ: a.value,
          prescriber_office_location: this.locationName || undefined,
          api_key: api_key,
          patient_id: patient_id,
        };

        this.reqSubcription.push(
          this.filterService.frmExecutionQuery(obj, this.item.config?.widget_endpoint || 'pss/get-pss-data').subscribe(
            (res: any) => {
              let historyData: any[] = [];
              if (res) {
                historyData = [];
                Object.entries(_.groupBy(res, "du_patient_id")).forEach(
                  (m: any) => {
                    historyData.push({
                      patient_id: m[0],
                      patient_status_history: m[1],
                    });
                  }
                );
                if (a.value == "P") {
                  sessionStorage.setItem(
                    "pending",
                    JSON.stringify(historyData ? historyData : [])
                  );
                } else {
                  sessionStorage.setItem(
                    "non-pending",
                    JSON.stringify(historyData ? historyData : [])
                  );
                }
              }
            },
            (err) => {
              this.noRowsTemplate = `<span>No Data</span>`;
            }
          )
        );
      });
      // }
    }
  }

  onPageSizeChanged(res: any) {
    this.paginationPageSize = res;
    
    if (this.paginationPageSize > 100) {
      this.paginationPageSize = 100
    }

    this.gridApi.paginationSetPageSize(res);
    let config = {
      dashboardKey: this.dashboardKey,
      filterValue: this.filterValue,
      search: this.filterSearchParams
    }
    // this.gridStateService.saveGridStates({ pageSize: this.paginationPageSize }, config);
    this.gridStateService.saveGridStates({ id: this.widgetUniqKey, config: { pageSize: this.paginationPageSize } })

  }

  sliderValueBinds(event: any) {
    if (event) {
      this.sliderValue = event;
      this.filterService.sliderValue = this.sliderValue;

      this.refreshAlertData();
    }
  }

  loadDataNewGridConfig() {
    this.nullColumnEvaluated = false;
    this.columnDefs = []
    this.defaultColumnDefs = []
    this.sortDesignModel = [];
    let cfg = this.item.config;
    // console.log(cfg)
    this.report_type = cfg["default_selected_report_typ"]?.["value"].toUpperCase();

    cfg.selected_column.forEach((res: any) => {
      res.property_CB.forEach((cb: any) => {
        if (cb.name == "Add Column") {
          if (cb.value) {
            var coldef: any = {
              headerName: res.api_resp_column_display_nm,
              field: res.api_resp_column_nm,
              hide: false,
              cellClass: "cell-wrap-text",
              cacheQuickFilter: true,
              autoHeight: false,
              menuTabs: this.menuTabs,
              minWidth: 150,
              configuration: res,
              endpoint: this.item.config?.widget_endpoint || 'pss/get-pss-data',
              headerTooltip: res.api_resp_column_display_nm,
            };

            if (res?.itHasSortable == undefined) {
              coldef['sortable'] = true;
            } else {
              coldef['sortable'] = res?.itHasSortable || false;
            }

            if (coldef['sortable']) {
              coldef['sort_column_name'] = res?.sort_column_name;
              if (res?.sort_column_name) {
                let obj = {
                  id: coldef.field,
                  sort: res?.sort_column_name
                }
                this.sortDesignModel.push(obj)
              }
            }

            if (res.removeNullColumns) {
              coldef['removeNullColumns'] = res.removeNullColumns || false;
            }

            if (res?.isDefaultColumn == undefined) {
              coldef["isDefaultColumn"] = true;
            } else {
              coldef["isDefaultColumn"] = res.isDefaultColumn || false;
            }

            if (res?.itHasMinWidth) {
              coldef["minWidth"] = res?.colMinWidth || 150
            }

            coldef["uniqNavigationColumn"] = res?.isHastagLinkCol || res?.isLinkCol || false;
            if (res.api_resp_column_nm == "current_status") {
              coldef.minWidth = 280;
            }

            if (res.api_resp_column_nm == "status_group_frm") {
              coldef.minWidth = 280;
            }

            if (res.api_resp_column_nm == "du_patient_encrypted_id") {
              coldef.minWidth = 240;
            }

            if (res.api_resp_column_nm == "du_patient_id_encrypt") {
              coldef.minWidth = 240;
            }

            if (res.api_resp_column_nm == "patient_status_group") {
              coldef.minWidth = 240;
            }

            if (res.api_resp_column_nm == "hub_last_status_reason") {
              coldef.minWidth = 240;
            }

            if (res.api_resp_column_nm == "com_sp_last_status_reason") {
              coldef.minWidth = 240;
            }

            if (res.api_resp_column_nm == "status_group") {
              coldef.minWidth = 280;
            }

            if (res.api_resp_column_nm == "hub_last_status_code") {
              coldef.minWidth = 280;
            }

            if (res.api_resp_column_nm == "hub_last_reason_code") {
              coldef.minWidth = 280;
            }

            if (res.api_resp_column_nm == "sp_last_reason_code") {
              coldef.minWidth = 280;
            }

            if (res.api_resp_column_nm == "current_sp_patient_id") {
              coldef.minWidth = 240;
            }

            if (res.api_resp_column_nm == "payer_nm") {
              coldef.minWidth = 240;
            }

            if (res.api_resp_column_nm == "prescriber_address") {
              coldef.minWidth = 250;
            }

            if (res.api_resp_column_nm == "prescriber_id") {
              coldef.minWidth = 300;
            }

            if (res.api_resp_column_nm == "prescriber_nm") {
              coldef.minWidth = 200;
            }

            if (res.api_resp_column_nm == "alert" || res.api_resp_column_nm == "alert_col_value") {
              coldef.minWidth = 230;
            }

            if (res.api_resp_column_nm == "alert") {
              coldef["menuTabs"] = this.menuTabss;
            }

            if (res.isAlignment && res.isTextColorCondition) {
              coldef["cellStyle"] = {
                color: res.isTextColor,
                textAlign: res.isAlignment.toLowerCase(),
              };
            } else if (res.isAlignment && !res.isTextColorCondition) {
              coldef["cellStyle"] = {
                textAlign: res.isAlignment.toLowerCase(),
              };
            } else if (res.isTextColorCondition) {
              coldef["cellStyle"] = { color: res.isTextColor };
            }

            // Data Types
            if (res.isDataType == "date") {
              let a = res.isPrefix || "";
              let b = res.issuffix || "";
              let formats = "MM/DD/YYYY";
              if (!res?.useCustomDateFormat) {
                formats = res?.selectedDateFormat || 'MM/DD/YYYY';
              } else {
                formats = res?.customDateFormat || 'MM/DD/YYYY';
              }
              coldef["valueGetter"] = (params: any) => params.data?.[res.api_resp_column_nm] ? a + " " + moment(params.data[res.api_resp_column_nm]).format(formats) + " " + b : "";
            }

            if (res.isDataType == "integer") {
              let a = res.isPrefix || "";
              let b = res.issuffix || "";
              coldef["valueFormatter"] = (params: any) => {
                if (params.value == null || params.value === "") return "";
                const num = Number(params.value);
                // Numeric values are always comma separated (e.g. 1234567.5 -> 1,234,567.5)
                if (isNaN(num)) return a + "" + params.value + "" + b;
                return a + "" + this.currency.transform(num, "", "", "1.0-2") + "" + b;
              };
            }

            // String for Init cap and upper and lower
            if (res.isDataType == "string") {
              let a = res.isPrefix || "";
              let b = res.issuffix || "";
              if (res.isTextCase == "from_db") {
                coldef["valueFormatter"] = (params: any) => params.value ? a + " " + params.value + " " + b : "";
              } else if (res.isTextCase == "init") {
                coldef["valueFormatter"] = (params: any) => params.value ? a + " " + params.value.toLowerCase().split(" ").map((s: any) => s.charAt(0).toUpperCase() + s.substring(1)).join(" ") + " " + b : "";
              } else if (res.isTextCase == "cap") {
                coldef["valueFormatter"] = (params: any) => params.value ? a + " " + params.value.toUpperCase() + " " + b : "";
              } else {
                coldef["valueFormatter"] = (params: any) => params.value ? a + " " + params.value.toLowerCase() + " " + b : "";
              }
            }

            // Conditional Formatter
            if (res.conditional_format == true || res.isActionIcon == true) {
              coldef["cellRendererFramework"] = PatientValueGetterComponent;
              coldef["cellRendererParams"] = (params: any) => {

                if (!params.data) return;
                let selectedData: any;
                let selectedStyles: any;
                let columnClickData: any;

                if (res.conditional_formatting_value) {
                  let abData = res.conditional_formatting_value.filter((flr: any) => flr.isSelect == true);
                  selectedData = abData;
                }

                if (res.isActionColumn == true) {
                  if (res.isSelectionTypeColumn == "Column Click") {
                    columnClickData = {
                      api_key: res.isSelectionColumnAPI,
                      params: res.isSelectionColumnParameter,
                    };
                  }
                }

                // icon for Actions
                if (res.isActionIcon == true) {
                  selectedStyles = {
                    icon: res.isActionIconName,
                    color: res.isActionIconColor,
                    position: res.isActionPosition,
                    extraText: {
                      prefix: res.isPrefix,
                      suffix: res.issuffix,
                    },
                  };

                  if (res.isEventsInIcon == true) {
                    let iconsClick = {
                      iconType: res.isSelectionTypeIcon,
                      iconApi: res.isSelectionIconAPI,
                      iconPara: res.isSelectionIconParameter,
                    };

                    Object.assign(selectedStyles, { iconsClickEvent: iconsClick });
                  }
                }

                return this.cellRendererValueGetter(selectedData, params.data[res.condition_reference_column], params.value, selectedStyles, res) || "" + params.value;
              };
            }
            //
            // Actions For Column
            if (res.isActionColumn == true) {
              if (res.isSelectionTypeColumn == "Column Hover Over") {
                if (res.isSelectionColumnAPI) {
                  // API For Local Status for Hover Over
                  if (!this.loadFirstTime) {
                    this.localApi();
                    this.loadFirstTime = true;
                  }
                  (coldef["tooltipComponent"] = HoverOverComponent),
                    (coldef["tooltipValueGetter"] = (params: any) => {
                      let formatData = res.conditional_formatting_value;
                      let selectedvalue = {
                        api_key: res.isSelectionColumnAPI,
                        parameter: res.isSelectionColumnParameter,
                      };

                      let component: any;
                      if (res.currentStatusPupups) {
                        component = res.currentStatusPupups;
                      }
                      return this.tooltipValueGetter(
                        params,
                        selectedvalue,
                        formatData,
                        component
                      );
                    });
                }
              } else if (res.isSelectionTypeColumn == "Alerts") {
                if (res.alertSelectionPosibleValues) {
                  sessionStorage.setItem(
                    "alertIcons",
                    JSON.stringify(res.alertSelectionPosibleValues)
                  );
                  coldef["cellRendererFramework"] = AlertIconComponent;
                  coldef["cellRendererParams"] = (params: any) => {
                    return {
                      alertIcons: res.alertSelectionPosibleValues,
                      dataFromPatient: params,
                    };
                  };
                }
              }
            }

            if (res.isFollowUp) {
              coldef["cellRendererFramework"] = PatientsFollowUpComponent;
              coldef["minWidth"] = 260;
            }
            
            if(res.flagBasedBadges) {
              coldef["flagBasedBadges"] = {
                label: res.flagLabel,
                column_nm: res.flagBasedBadgesColumn,
                color: res.flagBgColor,
                excel_label: cfg.selected_column.find((f:any) => f.api_resp_column_nm == res.flagBasedBadgesColumn)?.api_resp_column_display_nm || res.flagExcelLabel || res.flagLabel
              }
              coldef["cellRendererFramework"] = PatientsBadgesComponent;
            }
            
            if(res.isNoteAction) {
              coldef['configuration']['uniq_key'] = {
                dashboardKey: res.individualNotesDashboardKey,
                payloadKeyName: res.individualPayloadKeyName,
                payloadKey: res.individualPayloadKey,
                payloadKeyName1: res.individualPayloadKeyName1,
                payloadKey1: res.individualPayloadKey1,
                conversationKey: res.individualConversationKey,
                groupKey: res.notesIndividualFilterByKey,
                prefix: res.individualNotesPrefix,
                suffix: res.individualNotesSuffix,
                isHashtag: res.isHashtags,
                displayCaseIcon: res.displayCaseIcon,
                caseVariable: res.caseVariable,
                caseCtgyVariable: res.caseCtgyVariable,
                caseVariableReplaced: res.caseVariableReplaced
              };
              this.hashtagInList = res.isHashtags;
              coldef["cellRendererFramework"] = PatientsActionNotesComponent;
            }

            if (res.isFlag) {
              // coldef["cellRendererFramework"] = PatientsFlagsComponent;
              // coldef["minWidth"] = 60;
            }

            this.defaultColumnDefs.push(coldef);
          }
        }

        if (cb.name == " Hidden" || cb.name == "Hidden") {
          if (cb.value) {
            this.headerNames.push(res.api_resp_column_nm);
            this.phiDisplayNames.push(res.api_resp_column_display_nm);
          }
        }
      });
    });

    // Hide Flag Column
    this.defaultColumnDefs = this.defaultColumnDefs.filter((f: any) => f.field != 'follow_up_highlight_flg');
    this.defaultColumnDefs = this.defaultColumnDefs.filter((f: any) => f.field != 'source_type');
    this.columnDefs = this.defaultColumnDefs.filter((f: any) => f.isDefaultColumn);
    this.getPreferences();

    setTimeout(() => {
      this.gridApi?.refreshCells({ force: true }); // Refresh cells safely

      // Onload PHI
      // this.gridColumnApi?.setColumnsVisible(this.headerNames, false);
    }, 1000);
  }

  getDataColor(params: any, valueFormat: any) {
    return { params, valueFormat };
  }

  // Mat Icon Dynamically set with cell Renderer Value Getter
  cellRendererValueGetter(
    rangeValue: any,
    param: any,
    value: any,
    selectedStyles: any,
    res: any
  ) {

    if (!selectedStyles) {
      if (!rangeValue) return null;
    }

    if (rangeValue && !selectedStyles) {
      let findData = rangeValue.find((f: any) => f.col_value?.toLowerCase() == param?.toLowerCase());
      if (findData) {
        let icon: any = findData.icon;
        let color: any = findData.color;
        return { icon, value, color, selectedStyles };
      } else {
        // console.log('param', param)
        if (value) {
          let color = this.getUniqueColorForParam(param, rangeValue);
          let fndData = rangeValue.find((f: any) => f.col_value?.toLowerCase() == "random");
          if (fndData) {
            let icon = fndData.icon;
            return { icon, value, color, selectedStyles };
          }
        }
      }
    } else if (rangeValue && selectedStyles) {
      if (rangeValue.length) {
        let fnd: any = rangeValue.find((res: any) => res.col_value?.toLowerCase() == param?.toLowerCase());
        if (fnd) {
          let icon = fnd.icon;
          let color = fnd.color;
          return { icon, value, color, selectedStyles };
        } else {
          if (value) {
            let color = this.getUniqueColorForParam(param, rangeValue);
            let fndData = rangeValue.find((f: any) => f.col_value?.toLowerCase() == "random");
            if (fndData) {
              let icon = fndData.icon;
              return { icon, value, color, selectedStyles };
            }
          } else if (res.isEventsInEmptyColumn) {
            return { value, selectedStyles };
          }
        }
      } else {
        return { selectedStyles };
      }
    } else if (selectedStyles) {
      return { value, selectedStyles };
    }
  }

  // Function to get a unique and consistent color for each param (col_value)
  getUniqueColorForParam(param: string, rangeValue: any): string {
    if (!this.colorMap[param]) {
      let newColor;
      do {
        newColor = this.getRandomColor(); // Generate a new color
      } while (this.isColorUsedByAnotherParam(newColor, rangeValue, param)); // Ensure it's not used by another col_value

      this.colorMap[param] = newColor; // Assign the new unique color
    }
    return this.colorMap[param];
  }

  // Function to check if the generated color is already assigned to a different col_value
  isColorUsedByAnotherParam(color: string, rangeValue: any, param: string): boolean {
    return rangeValue.some((r: any) => r.color == color && r.col_value?.toLowerCase() != param?.toLowerCase());
  }

  // Function to generate a random color
  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  iconClickRendererValueGetter(
    params: any,
    api_key: any,
    parameter: any,
    style: any
  ) {
    return { params, api_key, parameter, style };
  }

  tooltipValueGetter(
    params: any,
    selectedValue: any,
    formatValue: any,
    component: any
  ) {
    const lineBreak = true;
    return { params, selectedValue, formatValue, component, lineBreak }; // params.data['patient_id']
  }

  loadApiDataCount() {
    if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
      let obj: any = {
        activity_since_days: this.filterService.sliderValue || undefined,
        report_typ: this.filterService.report_type || "D",
        prescriber_office_location: this.locationName || undefined,
        module_key: this.apiService.getModuleKey()
      };

      // Cancel previous count API if it's still active
      if (this.countApiSubscription) {
        this.countApiSubscription.unsubscribe();
      }

      // Cancel any in-flight rows request so a stale response can't resolve
      // after a newer search and overwrite rowDataCount with the wrong value.
      if (this.rowDataSubscription) {
        this.rowDataSubscription.unsubscribe();
      }

      obj["api_key"] = this.item.config?.["list_of_api_count"]?.["api_key"] || 6002;
      let endPoint = this.item.config?.["list_of_api_count_endpoint"];

      obj["phi_flg"] = this.filterService.phiChecked ? "Y" : "N";
      if (this.filterValue) {
        Object.assign(obj, (this.filterSearchParams || {}));
      }

      if (this.searchDynamicParams && Object.keys(this.searchDynamicParams).length > 0) {
        Object.assign(obj, this.searchDynamicParams);
      }

      let query = Object.assign({}, this.filterService.baseQuery, obj);
      this.onBtShowLoading();
      this.countApiSubscription = this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || "PSS/get-pss-data"}`, query).subscribe((res: any) => {
        const countKey = this.item.config?.patientCountVar || 'patient_count';
        this.rowDataCount = Number(res?.[0]?.[countKey] ?? 0) || 0;
        this.serverSidePagination();
      }, (err: any) => {
        this.rowDataCount = 0;
        this.rowData = [];
        this.error_name = friendlyApiErrorMessage(err);
        this.onBtHide();
        // this.serverSidePagination()
      })
      this.reqSubcription.push(this.countApiSubscription);
    }
  }

  isPHIFunc(event: any) {
    this.onBtShowLoading();
    this.phiChecked = event;
    this.filterService.phiChecked = event;

    // Emit PHI state change to trigger security restrictions
    // this.filterService.isPHIFunc.next(event);

    // Show or remove PHI warning overlay based on toggle state
    if (this.filterService.phiChecked && this.filterService.hasPhiHiddenToggle) {
      sessionStorage.setItem('phiLogged', 'phiLogged')
      this.phiSecurityService.setVerified(true);
      this.phiSecurityService.showPHIWarningOverlay();
      this.phiSecurityService.enableRestrictions();
    } else {
      sessionStorage.removeItem('phiLogged')
      this.phiSecurityService.setVerified(false);
      this.phiSecurityService.removePHIWarningOverlay();
      this.phiSecurityService.disableRestrictions();
    }

    // set Search state
    let config = {
      id: this.widgetUniqKey,
      config: {
        dashboardKey: this.dashboardKey,
        phi_flag: this.filterService.phiChecked
      }
    }
    this.gridStateService.saveGridStates(config);

    this.serverSidePagination();
  }

  // Apply or remove visual styling to PHI column headers  @param apply - true to apply PHI styling, false to remove it
  applyPhiColumnStyling(apply: boolean): void {
    if (!this.headerNames || this.headerNames.length === 0 || !this.columnDefs) {
      return;
    }

    // Apply/remove the header class directly on columnDefs
    this.columnDefs.forEach((colDef: any) => {
      if (this.headerNames.includes(colDef.field)) {
        if (apply) {
          // Add PHI header class
          const existing = colDef.headerClass || '';
          if (!existing.includes('phi-column-header')) {
            colDef.headerClass = existing ? `${existing} phi-column-header` : 'phi-column-header';
          }
        } else {
          // Remove PHI header class
          if (colDef.headerClass) {
            colDef.headerClass = colDef.headerClass
              .replace('phi-column-header', '')
              .trim();
          }
        }
      }
    });

    // Refresh the header to apply the changes
    this.gridApi?.refreshHeader();
  }

  onCellClicked(event: any) {
    this.selectedColumnData = event?.data;

    // Task icon click detection for Task Management
    // if (event?.event?.target?.closest('.task-icon-btn')) {
    //   event.event.stopPropagation();
    //   this.openTaskManagementDialog(event.data);
    //   return;
    // }

    // if(event?.colDef?.field=='alert' || event?.colDef?.field == "alert_col_value" || event?.colDef?.field == "action_column") {
    //   this.alertColumnAvailable = event?.data;
    //   this.clickedColumnConfig = event?.colDef?.configuration;
    // } else {
    //   this.alertColumnAvailable = ""
    //   this.clickedColumnConfig = ""
    // }
    if (event?.colDef?.configuration?.isLinkCol) {

      // Storing for Patient Card if there!
      let resData = {
        patient_case_status: event.data.case_status,
        patient_reason_status: event.data.status_reason,
        patient_id: event.data.patient_id,
      };
      this.newFilterService.setPatientStatusData(resData);
      this.newFilterService.setPatientStatusBaseQuery(this.filterService.baseQuery);

      let patientId = event?.colDef?.configuration?.selectNavigatePart;
      let colDef: any = this.columnDefs.find((f: any) => f.field == "status_group_frm" || f.field == "current_status")

      let patData = {
        report_typ: "D",
        api_key: 100202,
        data: this.setTheRequiredData(event.data, colDef),
        // configuration: colDef?.configuration,
        patient_id: event.data?.[patientId],
        source_patient_id: event.data?.['source_patient_id'],
        api_resp_column_nm: colDef?.configuration?.api_resp_column_nm,
        isSelectionIconParameter: colDef?.configuration?.isSelectionIconParameter,
        condition_reference_column: colDef?.configuration?.condition_reference_column,
        endpoint: this.item.config?.widget_endpoint
      }

      if (event.data?.['source_patient_id']) {
        let sour = { "source_patient_id": event.data?.['source_patient_id'] }
        sessionStorage.setItem("source_patient_id", JSON.stringify(sour));
      }

      sessionStorage.setItem("patDataStatusChange", JSON.stringify(patData));
      // this.newFilterService.sendData(patData);

      // Set Navigation
      let conf0: any = event?.colDef?.configuration;
      let nav: any = {
        dbJSON: conf0.dbJSON,
        s3JSON: conf0.s3JSON,
        pageName: conf0.s3JSON?.page_nm,
        isDashboardLevel: conf0.isDashboardLevel,
      };
      if (conf0.isNotes) {
        
        let actionFind:any = this.columnDefs.find((f:any) => f.field == 'action_column');
        
        let src_pat_id = event.data?.['source_patient_id'] || 
        
        event.data?.[actionFind?.configuration?.individualPayloadKey] ||
        event.data?.['patient_id'] || 
        event.data?.['prescriber_nm'] || '';

        
        nav['notes'] = {
          isNotes: conf0.isNotes || false,
          dashboardName: conf0.notesDisplayName,
          dashboardKey: conf0.notesDashboardKey,
          filterKey: conf0.uniqueDetailKey || 'patient_key',
          hashtagType: actionFind?.configuration?.individualNotesPrefix || '',
          hashtagKey: src_pat_id || null  
        }
      }

      this.routerHandlerService.navDetailInfo(nav);
      this.routerHandlerService.storingPayloadAndFilterForGrid(conf0, event.data, this.cardName);

      let query: any = Object.assign({}, this.decryptedParams, { cardId: event.data[conf0.selectNavigatePart] }, { tab_id: 0 }, { page: "list" });

      if (nav.pageName?.toString().replace(/\s+/g, '').toLowerCase() == 'patientcard') {
        query['crds'] = 'pacard'
      }

      if (event.data['pdrp_restricted_flg'] == 'Y') {
        query['pdrp'] = 'Y';
      }

      // Prescriber Name Header
      if (nav.pageName?.toString().replace(/\s+/g, '').toLowerCase() == 'prescribercard') {
        // Prescriber Name
        let prName = event?.colDef?.configuration?.api_resp_column_nm;
        if (event.data[prName]) {
          sessionStorage.setItem("navbar_prName", event.data[prName]);
          query['prescriber'] = event.data[prName];
        }
      }

      if (this.gridApi) {
        let baseConfig = {
          dashboardKey: this.dashboardKey,
          filterValue: this.filterValue,
          search: this.filterSearchParams
        }

        let sortModel: any = this.gridApi?.getModel();
        if (sortModel?.['cacheParams']?.sortModel?.length > 0) {
          let sortM = sortModel?.['cacheParams']?.sortModel;
          let sort: any = {};

          // let initSort = sortM[0].colId;
          let initSort = this.sortDesignModel.find((f: any) => f.id == sortM[0]?.colId)?.sort || sortM[0].colId;

          sort["sort_col"] = initSort;
          sort["sort_order"] = sortM[0].sort;

          // this.gridStateService.saveGridStates({ sort }, config);
          this.gridStateService.saveGridStates({ id: this.widgetUniqKey, config: { sort } });
        }
        const page = this.gridApi.paginationGetCurrentPage();
        let startIndex = this.startIndex;
        // this.gridStateService.saveGridStates({ page, startIndex }, config);
        this.gridStateService.saveGridStates({ id: this.widgetUniqKey, config: { page, startIndex } })
      }

      let queryMaped = this.navigationService.movePropertyToFirst(query, "tab_id");

      // Disable PHI mode before navigating to detail page
      // User must re-enable PHI on the detail page for security
      // if (this.phiChecked) {
        // console.log("🔒 PHI: Disabling PHI mode before navigation to detail page");
        // this.phiChecked = false;
        // this.filterService.isPHIFunc.next(false);

        // Update grid state
        // this.gridStateService.saveGridStates({
        //   id: this.widgetUniqKey,
        //   config: {
        //     dashboardKey: this.dashboardKey,
        //     phi_flag: false,
        //   },
        // });
      // }

      this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, queryMaped);
      
      // let currentTimeEncrypted = this.navigationService.currentTimeEncrypted('page');
      // this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${currentTimeEncrypted}`, queryMaped);
    }
  }

  // Open Task Management Dialog
  openTaskManagementDialog(rowData: any): void {
    const dialogRef = this.dialog.open(TaskManagementDialogComponent, {
      width: '80vw',
      maxWidth: '700px',
      height: 'auto',
      autoFocus: false,
      data: {
        du_patient_id: rowData?.du_patient_id || '',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.fetchDataAndKeepPage();
      }
    });
  }

  setTheRequiredData(rowdata: any, colDef: any) {
    if (rowdata && Object.keys(rowdata)?.length > 0) {
      let col = colDef?.configuration;

      let impColumn = [
        col?.api_resp_column_nm,
        col?.isSelectionIconParameter?.[0],
        col?.condition_reference_column,
        "patient_case_status",
        "patient_reason_status"
      ];

      // Create a shallow copy to avoid mutating the original grid data
      let clonedData = { ...rowdata };

      // Delete all keys not in impColumn
      Object.keys(clonedData).forEach((key) => {
        if (!impColumn.includes(key)) {
          delete clonedData[key];
        }
      });

      return clonedData;
    }
    return rowdata;
  }

  journeyPopupData(data: any) {

    let cfg = this.item.config;
    cfg.selected_column.forEach((res: any) => {
      res.property_CB.forEach((cb: any) => {
        if (cb.name == "Add Column") {
          if (cb.value) {
            if (data.colDef.field == res.api_resp_column_nm) {
              if (res.isActionColumn == true) {
                // if(!this.deviceDetectionService.isDesktop) {
                if (res.isSelectionTypeColumn == "Column Hover Over") {
                  if (res.isSelectionColumnAPI) {

                    let formatData = res.conditional_formatting_value;
                    let selectedvalue = {
                      api_key: res.isSelectionColumnAPI,
                      parameter: res.isSelectionColumnParameter,
                    };

                    let component: any;
                    if (res.currentStatusPupups) {
                      component = res.currentStatusPupups;
                    }

                    let dialogRef = this.dialog.open(HoverOverClickComponent, {
                      width: this.constantsService.MEDIUM_DIALOG_BOX_WIDTH,
                      // disableClose: this.constantsService.DIALOG_DISABLE_CLOSE,
                      panelClass: "du-custom-modalbox",
                      data: this.tooltipValueGetter(
                        data,
                        selectedvalue,
                        formatData,
                        component
                      )
                    });

                    dialogRef.afterClosed().subscribe((value) => {

                    });
                  }
                }
                // }

              }
            }
          }
        }
      });
    });
  }

  highlightSearchTextRenderer(params: any) {
    const value = params.value;
    const quickFilter = params.api.getQuickFilter();
    if (!quickFilter) {
      return value;
    }
    const parts = value.split(new RegExp(`(${quickFilter})`, "gi"));
    return parts
      .map((part: any) =>
        part.toLowerCase() === quickFilter.toLowerCase()
          ? `<span class="highlight">${part}</span>`
          : part
      )
      .join("");
  }

  // Quick Filter for Type to Search Filter
  onQuickFilterChanged(event: any) {
    this.filterValue = event;
  }

  searchDynamicParams: any;
  serverSideSearchEmits(event: any) {
    this.filterValue = event?.filterValue;
    this.filterSearchParams = this.filterValue ? event?.obj || '' : '';

    if (event?.hdr?.dynamic_payload && this.filterValue && event?.obj?.search_prm) {
      let fnd = event.hdr.searchByKey.find((f: any) => f.value == event.obj.search_prm);
      this.searchDynamicParams = {
        search_column_name: fnd.param,
        search_column_value: this.filterValue,
        search_data_type: fnd.datatype
      }
    } else {
      this.searchDynamicParams = {}
    }

    // set Search state
    let config = {
      id: this.widgetUniqKey,
      config: {
        dashboardKey: this.dashboardKey,
        filterValue: this.filterValue,
        search: this.filterSearchParams,
        searchDynamicParams: this.searchDynamicParams
      }
    }
    this.gridStateService.saveGridStates(config);

    this.onBtShowLoading();
    this.loadApiDataCount();
    // this.serverSidePagination()
  }

  selectedExportXls(column: any) {
    let query: any = this.filterService.baseQuery;
    query["export_nm"] = this.item.config['report_heading'];
    query["api_key"] = this.item.config?.["list_of_api"]?.['api_key'] || 6001;
    query["report_typ"] = this.filterService.report_type;
    query["column_nm"] = column;
    query["activity_since_days"] = this.filterService.sliderValue || undefined;

    query["phi_flg"] = this.filterService.phiChecked ? "Y" : "N";

    if (this.filterValue) {
      Object.assign(query, this.filterSearchParams || {});
    }

    if (this.searchDynamicParams && Object.keys(this.searchDynamicParams).length > 0) {
      Object.assign(query, this.searchDynamicParams);
    }

    this.reqSubcription.push(
      this.dataService.getExportCSV(query).pipe(debounceTime(1000)).subscribe((res: any) => {

        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = (this.item.config['report_heading'] || 'Excel') + '.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, err => {
        alert("Unable to Download the Excel. Please Try Again...")
      })
    );
  }

  preferenceEmitter() {
    ;
    let userProvidedColDef: any;

    if (this.gridColumnApi?.columnModel?.displayedColumns?.length) {
      userProvidedColDef = this.gridColumnApi.columnModel.displayedColumns.map(
        (m: any) => m.userProvidedColDef
      );
    } else {
      userProvidedColDef = [];
    }

    let displayColumn =
      userProvidedColDef.length === 0 ? this.columnDefs : userProvidedColDef;

    // Filter out hidden PHI columns from display columns
    if (this.headerNames.length > 0) {
      displayColumn = displayColumn.filter(
        (f: any) => !this.headerNames.includes(f.field),
      );
    }

    // Filter out hidden PHI columns from default columns
    let defaultColumns = this.defaultColumnDefs;
    if (this.headerNames.length > 0) {
      defaultColumns = defaultColumns.filter(
        (f: any) => !this.headerNames.includes(f.field),
      );
    }

    const dialogRef = this.dialog.open(PreferencesComponent, {
      width: '80%',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'du-preferences-dialog',
      data: {
        defaultColumns: defaultColumns,
        displayColumn: displayColumn,
        item: this.item,
        page_name: this.item.config["report_heading"],
        dashboardKey: this.dashboardKey,
        module_key: this.apiService.getModuleKey(),
        widgetUniqKey: this.widgetUniqKey,
        employeeKey: this.filterService.baseQuery?.employee_key || 0,
        pageKey: this.pageKey,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((value) => {
      this.defaultPreference = value;
      this.parsePreference(value, true)
    });
  }

  parsePreference(value: any, applied?: any) {
    if (value && value.length > 0) {
      const selectedColumnNames = value.map((v: any) => v.name);

      //  Build a map for fast lookup of original column definitions
      const colMap = new Map(
        this.defaultColumnDefs.map((col: any) => [
          col.headerName || col.field,
          col
        ])
      );

      let selectedPreference = [];

      if(this.filterService.phiChecked && this.filterService.hasPhiHiddenToggle) {
        selectedPreference = [
          selectedColumnNames[0],
          ...this.phiDisplayNames,
          ...selectedColumnNames.slice(1)
        ];
      } else {
        // Filter out PHI column display names when PHI is not checked
        selectedPreference = selectedColumnNames.filter(
          (name: string) => !this.phiDisplayNames.includes(name)
        );
      }

      // Reorder based on user selection
      const orderedColumnDefs = selectedPreference
        .map((name: string) => colMap.get(name))
        .filter((col: any) => !!col); // remove undefined just in case

      //  Set new column definitions in the selected order
      this.columnDefs = orderedColumnDefs;

      // Apply PHI styling after columnDefs are set
      this.applyPhiColumnStyling(this.filterService.phiChecked && this.filterService.hasPhiHiddenToggle);
      if (applied) {
        this.serverSidePagination();
      }
      // this.gridApi.setColumnDefs(this.columnDefs);
    }
  }

  setPreferencesColumn() {
    let data = this.columnDefs;
    if (data?.length > 0) {
      let column = '';
      data.forEach((f: any, index: number) => {
        column += `${f.field}${index < data.length - 1 ? ',' : ''}`;
      });
      return column
    }
    return ''
  }

  exportXls() {

    let userProvidedColDef: any;
    if (this.gridColumnApi?.columnModel?.displayedColumns?.length) {
      userProvidedColDef = this.gridColumnApi?.columnModel?.displayedColumns.map((m: any) => m.userProvidedColDef);
    } else {
      userProvidedColDef = [];
    }

    let init_sort = this.item.config?.["initial_sorting"]?.api_resp_column_nm || "patient_initiation_date";
    let obj = {
      sort_col: init_sort,
      sort_order: this.item.config?.["initial_sorting_order"] || "desc"
    }

    let column = userProvidedColDef.length == 0 ? this.columnDefs : userProvidedColDef;

    // Filter out hidden PHI columns if PHI is unchecked
    if (this.headerNames.length > 0) {
      column = column.filter((f: any) => !this.headerNames.includes(f.field));
    }
    
    let rawColumns = column.filter((f: any) => f?.flagBasedBadges && f?.flagBasedBadges?.column_nm);
    
    if(rawColumns && rawColumns.length > 0) {
      rawColumns.forEach((m:any) => {
        column.push({
          field: m.flagBasedBadges?.column_nm,
          headerName: m.flagBasedBadges?.excel_label || m.flagBasedBadges?.label,
          hide: true 
        })
      })
    }
    
    // let initSort = this.sortModel?.[0]?.colId;
    let initSort = this.sortDesignModel.find((f: any) => f.id == this.sortModel?.[0]?.colId)?.sort || this.sortModel?.[0]?.colId;
    const dialogRef = this.dialog.open(ServerExportPopupComponent, {
      data: {
        column: column,
        item: this.item,
        rowDataCount: this.rowDataCount,
        filterValue: this.filterSearchParams,
        searchDynamicParams: this.searchDynamicParams,
        sortModel: this.sortModel && this.sortModel?.length != 0 ? {
          sort_col: initSort,
          sort_order: this.sortModel?.[0]?.sort
        } : obj
      },
      disableClose: true
    });
  }

  getInfoDetail() {
    let data = {
      api_key: this.item.config.list_of_api?.api_key || 0,
      widget_key: this.item.config.widgetKey,
      page_key: this.pageKey,
      brand_key: this.filterService.baseQuery?.brand_key
    };
    this.reqSubcription.push(
      this.dataService.getInfoDetail(data).subscribe((res: any) => {
        this.infoData =
          res && res[0] ? res[0] : { info_header: "No Info Data Found" };
      })
    );
  }

  @ViewChild("fs") fs!: ElementRef;
  @ViewChild("gridList") gridList!: ElementRef;
  @HostBinding("class.is-fullscreen") isFullscreen = false;
  isActive = false;

  openFullscreen() {
    this.isFullscreen = true;
    const el = this.fs.nativeElement;

    if (this.filterService.phiChecked && this.filterService.hasPhiHiddenToggle) {
      this.phiSecurityService.showPHIWarningOverlay();
    }

    if (!document.fullscreenElement) {
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      }
    }
    this.isActive = true;
  }

  @HostListener('fullscreenchange')
  @HostListener('webkitfullscreenchange')
  @HostListener('mozfullscreenchange')
  @HostListener('MSFullscreenChange')
  screenChange() {
    this.isFullscreen = !!document.fullscreenElement;
    if (this.filterService.phiChecked && this.filterService.hasPhiHiddenToggle) {
      this.phiSecurityService.showPHIWarningOverlay();
    }
  }

  closeFullscreen() {
    this.isFullscreen = false;
    this.isActive = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  }

  loadStatusChange(data: any) {
    //
    let uniqId = data?.isSelectionIconParameter?.[0];
    let column = data?.api_resp_column_nm;
    let ref_col = data?.condition_reference_column;
    // let uniqId = data?.configuration?.isSelectionIconParameter?.[0];
    // let column = data?.configuration?.api_resp_column_nm;
    // let ref_col = data?.configuration?.condition_reference_column;

    // Save the current state of the grid (start row, end row)
    const currentPage = this.gridApi.paginationGetCurrentPage();
    const pageSize = this.gridApi.paginationGetPageSize();

    // Find the index of the row to be updated in the rowData array
    const rowIndex = this.rowData.findIndex(
      (res: any) => res[uniqId] == data?.data[uniqId]
    );

    if (rowIndex !== -1) {
      // Update the row data with the new values
      const updatedRow = {
        ...this.rowData[rowIndex], // Keep existing data
        case_status: data.patient_case_status,
        status_reason: data.patient_reason_status,
        current_status: data.patient_case_status + "-" + data.patient_reason_status,
        [column]: data.patient_reason_status,
        [ref_col]: data.patient_case_status
      };

      // Update the rowData array
      this.rowData[rowIndex] = updatedRow;

      // Update the datasource to reflect changes in the grid
      const datasource: IDatasource = {
        getRows: (params: IGetRowsParams) => {
          let rowCount = params.startRow + this.rowData.length;
          let lastRow =
            this.rowData.length < params.endRow - params.startRow
              ? rowCount // Indicates the end of the data
              : -1; // Indicates more data may be available

          params.successCallback(this.rowData, lastRow);

          setTimeout(() => {
            this.gridApi.refreshCells();
          }, 100);
        },
      };

      // Reassign the datasource to the grid
      this.gridApi.setDatasource(datasource);

      // Set the grid to the previous page
      setTimeout(() => {
        this.gridApi.paginationGoToPage(currentPage);
      }, 0);
    }
  }

  getMainMenuItems(params: GetMainMenuItemsParams): (string | MenuItemDef)[] {
    //
    const defaultItems: any = params.defaultItems.slice();
    let pinSubMenuIndex: any = defaultItems.findIndex((item: any) => item === "pinSubMenu");
    if (pinSubMenuIndex >= 0) {
      defaultItems[pinSubMenuIndex] = null;
      defaultItems[pinSubMenuIndex + 1] = null;
    }
    return defaultItems;
  }

  // getPhiUserAccess(data:any) {
  //   this.phiAccessSubscription?.unsubscribe();
  //   this.hasPhiHiddenToggle = false;
  //   if(this.filterService.isEmptyObject(data) == false) {
  //     let obj = Object.assign({}, data, {'user_id': this.sessionService.getUsername()})
  //     this.phiAccessSubscription = this.dataService.getPhiUserAccess(obj).subscribe((res:any) => {
  //       this.hasPhiHiddenToggle = res;

  //       if(sessionStorage.getItem('phiLogged') && this.hasPhiHiddenToggle) {
  //         this.phiChecked = true;
  //         this.filterService.phiChecked = this.phiChecked;
  //       }

  //       // Show PHI warning overlay if PHI was enabled (persists across refresh)
  //       if (this.phiChecked && this.hasPhiHiddenToggle) {
  //         this.phiSecurityService.showPHIWarningOverlay();
  //       }
  //     });
  //   }
  // }

  ngOnDestroy(): void {
    // Clean up PHI timer subscription
    if (this.phiTimerSubscription) {
      this.phiTimerSubscription.unsubscribe();
      this.phiTimerSubscription = null;
    }

    window.removeEventListener('scroll', this.onDocScroll, true);

    this.countApiSubscription?.unsubscribe();
    this.rowDataSubscription?.unsubscribe();
    this.phiAccessSubscription?.unsubscribe();
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

}